import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import { AppPath } from '../../../AppPath'
import { DisclosureRouter, ProposalReferralPage } from '../disclosure'
import { ProposalPath } from '../ProposalPath'

export const ProposalReferredRoutes: FunctionComponent = () => (
  <Routes>
    <Route index element={<ProposalReferralPage />} />

    <Route
      path={ProposalPath.DISCLOSURE + AppPath.WILDCARD}
      element={<DisclosureRouter />}
    />

    <Route path='*' element={<Navigate to={AppPath.HOME} />} />
  </Routes>
)
